<template>
  <div class="ContentPickModal">
    <el-dialog
      title=""
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="handleOpen"
      width="30%"
    >
      <div style="display: flex; align-items: center">
        <el-form
          ref="form"
          :model="formData"
          size="mini"
          label-width="90px"
          style="width: 100%"
        >
          <el-form-item label="内容形式:" prop="contentPattern">
            <el-radio-group
              v-model="formData.contentPattern"
              style="margin-left: 30px"
            >
              <el-radio
                v-for="item in contentTypeArr"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!--文本转语音-->
          <template v-if="formData.contentPattern === 'audioText'">
            <AudioText :formData="formData" @onOpenPickTextMaterialModal="onOpenPickTextMaterialModal"></AudioText>
          </template>
          <!--视频-->
          <template v-if="formData.contentPattern === 'video'">
            <el-form-item label="上传视频:">
              <template v-if="videoUrl">
                <y-j-video style="width: 400px; height: 200px" :src="videoUrl"></y-j-video>
                <div style="text-align: right; width: 400px">
                  <el-button
                    class="btn"
                    size="mini"
                    type="primary"
                    @click="handleUploadNewVideo"
                    >重新上传
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  drag
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :before-upload="beforeUploadVideo"
                  :on-change="handleVideoChange"
                >
                  <i class="el-icon-upload"></i>
                  <div>
                    <el-button
                      class="btn"
                      size="mini"
                      type="primary"
                      slot="trigger"
                      >上传视频
                    </el-button>
                    <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      data-type="video"
                      @click="pickMaterial"
                      >素材库
                    </el-button>
                  </div>
                </el-upload>
              </template>
            </el-form-item>
          </template>
          <!--音频-->
          <template v-if="formData.contentPattern === 'audio'">
            <el-form-item label="上传音频:">
              <template v-if="audioUrl">
                <y-j-video
                  style="width: 400px; height: 200px"
                  :src="audioUrl"
                />
                <div style="text-align: right; width: 400px">
                  <el-button
                    class="btn"
                    size="mini"
                    type="primary"
                    @click="handleUploadNewAudio"
                    >重新上传
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  drag
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :before-upload="beforeUploadAudio"
                  :on-change="handleAudioChange"
                >
                  <i class="el-icon-upload"></i>
                  <div>
                    <el-button
                      class="btn"
                      size="mini"
                      type="primary"
                      slot="trigger"
                      >上传音频
                    </el-button>
                    <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      data-type="audio"
                      @click="pickMaterial"
                      >素材库
                    </el-button>
                  </div>
                </el-upload>
              </template>
            </el-form-item>
          </template>
          <!--图片-->
          <template v-if="formData.contentPattern === 'image'">
            <el-form-item label="图片：">
              <div class="itemBox">
                <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="handleImgChange"
                  :before-upload="beforeImageUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div>
                    <el-button
                      class="btn"
                      v-if="imageUrl"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      >重新上传
                    </el-button>
                    <el-button
                      class="btn"
                      v-else
                      size="mini"
                      type="primary"
                      slot="trigger"
                      >上传图片
                    </el-button>
                    <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      data-type="image"
                      @click="pickMaterial"
                      >素材库
                    </el-button>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="footer">
        <el-button style="width: 80px" type="primary" @click="handleConfirm"
          >确定
        </el-button>
      </div>
    </el-dialog>
    <MaterialPickModal
      v-if="visible"
      :materialType="materialType"
      @onConfirmPickMaterial="onConfirmPickMaterial"
    ></MaterialPickModal>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { CONTENT_PATTERN } from "@/utils/constants";
import AudioText from "./AudioText.vue";
import MaterialPickModal from "../../MaterialCenter/components/MaterialPickModal.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "ContentPickModal",
  components: {
    YJVideo,
    AudioText,
    MaterialPickModal,
  },
  props: {
    materialInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    const 内容类型选项 = Object.keys(CONTENT_PATTERN).map((key) => {
      return {
        value: key,
        label: CONTENT_PATTERN[key],
      };
    });
    return {
      materialType: "audioText",
      formData: {},
      contentTypeArr: [...内容类型选项],
      // 音频
      audioUrl: "",
      // 视频
      videoUrl: "",
      //图片
      imageUrl: "",
      loading: false,
    };
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj"]),
    visible: {
      get() {
        return this.$store.state.courseCenter.contentPickModalVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "contentPickModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    handleOpen() {
      let info = {
        lessonContentTemplate: {
          material: {
            id: null,
            audioText: "",
            displayAudioText: "",
            audioSsmlText: "",
            filename: "",
            markFlag: null,
            markUuid: null,
            materialId: null,
            duration: null,
            materialUrl: "",
            type: "",
            speechRate: 1.0,
            voice: "zhiyuan",
          },
        },
        contentPattern: "audioText",
      };

      this.audioUrl = "";
      this.videoUrl = "";
      this.imageUrl = "";
      if (this.materialInfo != null) {
        info.contentPattern = this.materialInfo.contentPattern;
        info.lessonContentTemplate.material =
          this.materialInfo.lessonContentTemplate.material;

        info.lessonContentTemplate.material.type =
          this.materialInfo.contentPattern;
        if (this.materialInfo.contentPattern == "image") {
          this.imageUrl =
            this.materialInfo.lessonContentTemplate.material.materialUrl;
        } else if (this.materialInfo.contentPattern == "audio") {
          this.audioUrl =
            this.materialInfo.lessonContentTemplate.material.materialUrl;
        } else if (this.materialInfo.contentPattern == "video") {
          this.videoUrl =
            this.materialInfo.lessonContentTemplate.material.materialUrl;
        }
        this.materialType = this.materialInfo.contentPattern;
      }
      console.log(info)
      this.formData = info;
    },
    onConfirmPickMaterial(item) {
      if (!this.$store.state.courseCenter.contentPickModalVisible) {
        return;
      }
      console.log(item);
      if (this.materialType == "image") {
        this.imageUrl = item.url;
      } else if (this.materialType == "audio") {
        this.audioUrl = item.url;
      } else if (this.materialType == "video") {
        this.videoUrl = item.url;
      }
      this.formData.lessonContentTemplate.material.materialUrl = item.url;
      this.formData.lessonContentTemplate.material.duration = item.duration;
      this.formData.lessonContentTemplate.material.id = item.id;
      this.formData.lessonContentTemplate.material.materialId = item.id;
      console.log(this.formData);
    },
    handleConfirm() {
      //this.formData.lessonContentTemplate.material.id =
      //  this.formData.lessonContentTemplate.material.filename;
      if (
        this.formData.lessonContentTemplate.material.id == undefined ||
        this.formData.lessonContentTemplate.material.id == ""
      ) {
        this.formData.lessonContentTemplate.material.id = (
          (Math.random() + new Date().getTime()) *
          10000
        ).toString(32);
      }
      this.formData.lessonContentTemplate.material.type =
        this.formData.contentPattern;
      console.log(this.formData.lessonContentTemplate.material);

      this.$emit("refreshMaterial", this.formData);
      this.setData({ key: "contentPickModalVisible", value: false });
    },
    pickMaterial(event) {
      this.materialType = event.currentTarget.dataset.type;
      console.log(this.materialType);
      this.setData({ key: "materialPickVisible", value: true });
      event.stopPropagation();
    },    
    onOpenPickTextMaterialModal(){
      console.log("onOpenPickTextMaterialModal")
      this.materialType = "text";
      this.setData({key: "materialPickVisible", value: true});
    },
    //题干转音频
    handleChangeTitleAudio(val) {
      this.formData.lessonContentTemplate.material.audioText = val;
    },
    handlePrint() {
      console.log(this.formData);
    },
    // 音频
    beforeUploadAudio(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp3") {
        this.$message.error("上传音频仅支持mp3格式");
        return false; // 终止上传
      }
    },
    async handleAudioChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp3") {
        this.$message.error("上传视频只能是 MP3格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
        .then((res) => {
          console.log(res);
          console.log(this.ossUploadObj);
          console.log(this.formData.lessonContentTemplate);
          this.audioUrl = URL.createObjectURL(file.raw);
          this.formData.lessonContentTemplate.material.filename =
            this.ossUploadObj.filename;            
          this.formData.lessonContentTemplate.material.id = null;
          this.formData.lessonContentTemplate.material.materialId = null;
          this.formData.lessonContentTemplate.material.materialUrl =
            this.audioUrl;
          // 获取音频时长
          const audio = document.createElement("audio");
          audio.src = URL.createObjectURL(file.raw);
          audio.addEventListener("loadedmetadata", () => {
            if (Math.floor(audio.duration) === 0) {
              this.formData.lessonContentTemplate.material.duration = 1;
            } else {
              this.formData.lessonContentTemplate.material.duration =
                Math.floor(audio.duration);
            }
          });
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error("音频上传失败，请重新上传");
          this.audioUrl = "";
          console.log(e);
        });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewAudio() {
      this.audioUrl = "";
    },
    // 视频
    beforeUploadVideo(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp4") {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleVideoChange(file) {
      console.log("handleVideoChange");
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp4") {
        this.$message.error("上传视频只能是 MP4格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
        .then((res) => {
          console.log(res);
          this.videoUrl = URL.createObjectURL(file.raw);
          this.formData.lessonContentTemplate.material.filename =
            this.ossUploadObj.filename;
            
          this.formData.lessonContentTemplate.material.id = null;
          this.formData.lessonContentTemplate.material.materialId = null;
          this.formData.lessonContentTemplate.material.materialUrl =
            this.videoUrl;
          // 获取视频时长
          const video = document.createElement("video");
          video.src = URL.createObjectURL(file.raw);
          video.addEventListener("loadedmetadata", () => {
            if (Math.floor(video.duration) === 0) {
              this.formData.lessonContentTemplate.material.duration = 1;
            } else {
              this.formData.lessonContentTemplate.material.duration =
                Math.floor(video.duration);
            }
          });
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error("视频上传失败，请重新上传");
          this.videoUrl = "";
          console.log(e);
        });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewVideo() {
      this.videoUrl = "";
    },
    //图片
    async handleImgChange(file) {
      this.loading = true;
      const isJPG =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
        .then((res) => {
          console.log(res);
          this.imageUrl = URL.createObjectURL(file.raw);
          this.formData.lessonContentTemplate.material.filename =
            this.ossUploadObj.filename;
          this.formData.lessonContentTemplate.material.id = null;
          this.formData.lessonContentTemplate.material.materialId = null;
          this.formData.lessonContentTemplate.material.materialUrl =
            this.imageUrl;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.$message.error("图片上传失败，请重新上传");
          this.imageUrl = "";
        });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 880px;
  min-height: 550px;
  position: relative;
  margin-top: 15vh !important;

  .el-dialog__header {
    box-shadow: none;
  }
}

.contentBox {
  padding: 10px;
  min-height: 500px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .contentRow {
  }
  .addButton {
    height: 36px;
    width: 500px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #10689c;
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

//图片
.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-bottom: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-bottom: 10px;
}

//}
</style>
